import { render, staticRenderFns } from "./CY_GalleryPopup.vue?vue&type=template&id=6ff77837&scoped=true"
import script from "./CY_GalleryPopup.vue?vue&type=script&lang=js"
export * from "./CY_GalleryPopup.vue?vue&type=script&lang=js"
import style0 from "./CY_GalleryPopup.vue?vue&type=style&index=0&id=6ff77837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff77837",
  null
  
)

export default component.exports